module.exports = __webpack_public_path__ + "static/media/video.9cbd0d67.mp4";